import RenderPipeline from "../renderpipeline";
import ShaderService from "../../shader/shader_service";
import Camera from "../../scene/camera";
import Mesh from "../../geometry/mesh";
import MeshData from "../../geometry/meshdata";
import ResourceService from "../../resource/resourceservice";
import Transform from "../transform";
import { RENDER_SAMPLE_COUNT } from "../render_config";


export default class BlobShadowRenderPipeline extends RenderPipeline
{
    label:string;
    shader_name:string;
    width:number;
    height:number;
  
    camera_buffer: GPUBuffer | null = null;
    object_buffer: GPUBuffer | null = null;
    bind_group: GPUBindGroup | null = null;
    blob_shadow_buffer: GPUBuffer | null = null;
    mesh: Mesh;
 
 
   constructor(key:string,shader_name:string,width:number,height:number)
   {
      super(key+"_"+"blobshadow"); 
      this.label = key+"_"+"blobshadow";
      this.shader_name = shader_name;
      this.width = width;
      this.height = height;
      this.mesh = new Mesh();
   }
   
   async build(device: GPUDevice,
           format: GPUTextureFormat,
           shader_service: ShaderService,
           resource_service: ResourceService
         ): Promise<void> 
   {

    const shader = shader_service.get_render(this.shader_name);
    this.pipeline = device.createRenderPipeline({
          layout: "auto",
          label:this.label,
          vertex: {
            module: shader,
            entryPoint: "vs_main",
            buffers: [
              {
                arrayStride: 32,
                attributes: [
                  { shaderLocation: 0, offset: 0,  format: "float32x3" }, // position
                  { shaderLocation: 1, offset: 12, format: "float32x3" }, // normal
                  { shaderLocation: 2, offset: 24, format: "float32x2" }, // uv
                ],
              },
            ],
          },
          fragment: {
            module: shader,
            entryPoint: "fs_main",
            targets: [
              {
                format,
                blend: {
                  color: {
                    operation: "add",
                    srcFactor: "src-alpha",
                    dstFactor: "one-minus-src-alpha",
                  },
                  alpha: {
                    operation: "add",
                    srcFactor: "one",
                    dstFactor: "one-minus-src-alpha",
                  },
                },
              },
            ],
          },
          primitive: {
            topology: "triangle-list",
            cullMode: "none",
          },
          depthStencil: {
            format: "depth24plus",
            depthWriteEnabled: false,
            depthCompare: "less",
          },
        multisample: {
          count: RENDER_SAMPLE_COUNT,
        },
        });
    

    this.blob_shadow_buffer = device.createBuffer({
      size: 48,
      usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
    });

    this.camera_buffer = device.createBuffer({
          size: 64,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
     });
    
    this.object_buffer = device.createBuffer({
          size: 64,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
     });
    
        this.bind_group = device.createBindGroup({
          layout: this.pipeline.getBindGroupLayout(0),
          label:this.label+" cam_obj_bind_group ",
          entries: [
            { binding: 0, resource: { buffer: this.camera_buffer } },
            { binding: 1, resource: { buffer: this.object_buffer } },
            { binding: 2, resource: { buffer: this.blob_shadow_buffer } },
          ],
        });

      this.mesh.build(device, MeshData.make_plane(this.width, this.height));
  }

  prepare(device: GPUDevice, camera: Camera , transform:Transform): void 
    {
        if (!this.camera_buffer || !this.object_buffer || !this.blob_shadow_buffer) return;

        device.queue.writeBuffer(
            this.camera_buffer,
            0,
            camera.view_projection_matrix.buffer as ArrayBuffer,
            camera.view_projection_matrix.byteOffset,
            camera.view_projection_matrix.byteLength
            );

        device.queue.writeBuffer(
            this.object_buffer,
            0,
            transform.model_matrix.buffer as ArrayBuffer,
            transform.model_matrix.byteOffset,
            transform.model_matrix.byteLength
            );



          const blobShadowData = new Float32Array([
            0.58, 0.34, 1.7, 0.30,
            0.22, 0.18, 0.13, 0.04,
            0.025, 0.001, 0.0, 0.0,
          ]);


        device.queue.writeBuffer(
            this.blob_shadow_buffer,
            0,
            blobShadowData,
            0,
            blobShadowData.length
            );
    }

 
   draw(pass: GPURenderPassEncoder): void 
    {
        if (!this.pipeline || !this.bind_group) return;

        pass.setPipeline(this.pipeline);
        pass.setBindGroup(0, this.bind_group);
        this.mesh.draw(pass);
   }
}